import { render, staticRenderFns } from "./ChipButton.vue?vue&type=template&id=1a4a5826"
import script from "./ChipButton.vue?vue&type=script&lang=js"
export * from "./ChipButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports